//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
import * as settingAction from '../action/settingAction';
import * as helpAction from '../action/helpAction';

import Button from '@material-ui/core/Button';
//Material-ui

//Add

import PartPageTitle from './PartPageTitle';
//Dialog
//Icon



class Comp extends React.Component {
  constructor(props) {
		super(props);

    this.state = {
      newEmail: '',
      newEmailError: null,
      tokenForm: false,
      token: '',
      tokenError: null,
    }
	}

  componentDidMount() {
    document.title = 'メールアドレスの変更 - パートナーズ';
  }

  _newEmailEdit(value) {
  	var mail = value.replace(/[ 　]/g, '');
    this.setState({ newEmail: mail});

    let errorComment;

    if (mail.length === 0) {
  		errorComment = 'メールアドレスを入力してください';
  	}
    else if (mail.match(/^[a-zA-Z0-9!#$%&*+-/=?^_`{}|~.@]+$/) == null) {
  		errorComment = 'メールアドレスに入力できない文字があります';
  	}

  	if (errorComment) {
  		this.setState({newEmailError: errorComment});
  	}
  	else {
      this.setState({newEmailError: null});
    }
  }

  _tokenGet() {
    this.props.settingEmailEditTokenGet(this.state.newEmail, () => {
      this.setState({tokenForm: true});
    });
  }

  _tokenEdit(value) {
    let token = value.replace(/[ 　]/g, '');
    this.setState({token: token});

    let errorComment;
    if(token.length === 0) {
      errorComment = '認証コードを入力してください';
    }
    else if(!token.match(/^[0-9]+$/)) {
      errorComment = '入力できない文字が含まれています';
    }
    else if (token.length < 4 || token.length > 4) {
      errorComment = '4文字で入力してください';
    }
    if (errorComment) {
  		this.setState({tokenError: errorComment});
  	}
  	else {
      this.setState({tokenError: null});
    }
  }

  _tokenSubmit() {
    this.props.settingEmailEditSubmit(this.state.newEmail, this.state.token, () => {
      this.props.history.push('/setting/#emailNotificationBlock')
    });
  }

  render() {

    return (
      <div style={{maxWidth:'600px', margin:'auto'}}>
        <PartPageTitle
          title={(this.props.my.setting.email) ? 'メールアドレスの変更' : 'メールアドレスの登録'}
          onback={ '/setting/' }
        />
        <div style={{maxWidth:'400px', margin:'auto'}}>
        {
          (this.state.tokenForm === false) ? (
            <div>
              <div style={{padding:'10px'}}>
                <h3 align='center'> 登録するメールアドレスを入力してください</h3>
                <div>
                  <div style={{fontSize:'0.9em'}}>携帯アドレスは確認メールが届かない場合があります</div>
                  <div style={{fontSize:'0.9em'}}>GmailやYahooメールがお勧めです</div>
                  <input
                    type="text"
                    value={ this.state.newEmail }
                    style={{fontSize:'1.2em'}}
                    className="input_blue round12"
                    onChange={ (e) => this._newEmailEdit(e.target.value) }
                  />
                  <div style={{color:'red'}}>{this.state.newEmailError}</div>
                </div>
              </div>

              <div align='center' style={{padding:'10px'}}>
                <Button
                  variant="contained"
                  color="primary"
                  style={{minWidth:'240px'}}
                  onClick={ () => this._tokenGet() }
                  disabled={ (this.state.newEmail.match(/^[a-zA-Z0-9]+[a-zA-Z0-9!#$%&*+-/=?^_`{}|~.]+@[a-zA-Z0-9-._]+\.[a-z]+$/) == null) ? true: false }
                >
                  <div style={{fontSize:'1.4em'}}>確認メールを送信</div>
                </Button>
              </div>
            </div>
          ) : (
            <div>
              <div align='center' style={{padding:'10px'}}>
                {this.state.newEmail}<br/>
                のアドレスに認証コードを送信しました。<br/>
                本文に記載されている数字4桁を<br/>
                入力してください。
              </div>
              <div align='center'>
                <input
                  type="text"
                  maxLength='4'
                  value={ this.state.token }
                  style={{fontSize:'1.2em', maxWidth:'120px'}}
                  className="input_blue round12"
                  onChange={ (e) => this._tokenEdit(e.target.value) }
                />
              </div>
              <div align='center' style={{color:'red'}}>{this.state.tokenError}</div>


              <div align='center' style={{padding:'10px'}}>
                <Button
                  variant="contained"
                  color="primary"
                  style={{minWidth:'240px'}}
                  onClick={ () => this._tokenSubmit() }
                  disabled={ (this.state.token.match(/^[0-9]{4}$/) == null) }
                >
                  <div style={{fontSize:'1.4em'}}>送信</div>
                </Button>
              </div>

              <div align='center' style={{padding:'5px'}}>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={ () => this.props.helpOpen('category','bounce') }
                >
                  認証メールが届かない場合
                </Button>
              </div>

              <div align='center' style={{padding:'5px'}}>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={ () => this.setState({tokenForm: false}) }
                >
                  別のメールアドレスに送信する
                </Button>

              </div>

            </div>
          )
        }
        </div>
      </div>
    )

  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
    ...settingAction,
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
